module.exports = __webpack_public_path__ + "67ecf0f4ace2dccb2fa5ed7ba96a4b62.svg";